// extracted by mini-css-extract-plugin
export default {"root":"ContainerOverlay_root__jh05a","open":"ContainerOverlay_open__dHnxt"};